import Vue from 'vue'
import Cookies from 'js-cookie';
import App from './App'
import router from './router'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/iconfont/iconfont.css';
import '@/styles/index.scss' // global css
import store from './store'
import './icons' // icon

Vue.prototype.EventBus = new Vue()

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
})

let roles = ''
router.beforeEach((to, from, next) => {
  if (true || store.getters.token) { // 判断是否有token
    if (roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
      roles = 'admin';
      store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
        (async () => {
          const addRouters = await store.getters.addRouters
          await router.addRoutes(addRouters) // 动态添加可访问路由表
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          window.screenTop = 0;
        })()
      })
    } else {
      next() //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next();
    } else {
      next('/login'); // 否则全部重定向到登录页
    }
  }
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js